module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("display", function() {
    return [_c('a', {
      on: {
        "click": _vm.showModal
      }
    }, [_vm._v("\n      Buy Subscription\n    ")])]
  }, {
    "open": _vm.showModal
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-a5456eb0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5456eb0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/BuyCredits.vue
// module id = 492
// module chunks = 1